export default "__VITE_ASSET__Cyl$5M1Z__"